var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-layout d-flex"},[_c('admin-sidebar'),_c('div',{staticClass:"admin-content flex-grow-1"},[_c('admin-topbar'),_c('div',{staticClass:"container-fluid py-4 px-lg-4 px-3"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }